export function AccessDenied({
  email,
  onSignOut,
}: {
  email: string;
  onSignOut: () => Promise<void>;
}) {
  return (
    <div className="signin-screen">
      <h1>Access denied</h1>
      <p>
        The account <code>{email}</code> is not on the allowlist for this
        instance.
      </p>
      <button className="btn-primary" onClick={onSignOut}>
        Sign out
      </button>
    </div>
  );
}
